var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoApiKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "API Key") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/32px/icoKey",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Canvas",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-key-1033402",
    transform: "translate(4.000000, 4.000000)",
    stroke: "#FF6A61",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.02900732,5.32788694 C7.03024329,6.28896263 6.25225808,7.06695364 5.29118239,7.06571189 C4.33010637,7.06422895 3.54991163,6.28404039 3.54855076,5.32308055 C3.54719313,4.36188868 4.32514546,3.58389762 5.286376,3.58525531 C6.24733584,3.58661618 7.02749186,4.3667722 7.02900732,5.32788694",
    id: "Path",
    transform: "translate(5.288779, 5.325484) rotate(-45.000000) translate(-5.288779, -5.325484) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6450145,15.5816573 L13.6989809,15.5816573 L13.6989809,15.5816573 L13.6989809,18.0530973 L16.1774216,18.0530973 L16.1774216,20.5245374 L18.6558623,20.5245374 L18.6558623,22.5590685 C18.6558623,22.8376279 18.7720517,23.1035629 18.9764453,23.2928209 L19.1980212,23.4979887 C19.5465572,23.8207152 20.0040605,24 20.4790654,24 L22,24 C23.1045695,24 24,23.1045695 24,22 L24,20.5458484 C24,20.0131538 23.7874908,19.5024691 23.4095919,19.1270282 L13.5053527,9.28720837 L13.5053527,9.28720837 C14.3960423,6.85438455 13.8538834,3.99678198 11.878876,2.02735318 C9.16808153,-0.675784393 4.75335906,-0.675784393 2.04256456,2.02735318 C0.0288315014,4.03539823 -0.513327398,6.97023331 0.49353913,9.48028962 C0.842069851,10.3298471 1.34550312,11.1407884 2.04256456,11.8358809 C3.97884634,13.7666935 6.76709211,14.307321 9.20680716,13.4963797 L10.9256753,15.2763164 C11.1141151,15.471451 11.3737451,15.5816573 11.6450145,15.5816573 Z",
    id: "Path",
    strokeWidth: 2.2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoApiKey);
export default __webpack_public_path__ + "static/media/ico-api-key.0918e128037518a25db869a67919e3ba.svg";
export { ForwardRef as ReactComponent };